// 吃瓜雷达 · 站内数据（静态展示用）
export const brandName = "吃瓜雷达";

export const navLinks = [
  { id: "hot", label: "今日热榜", href: "#hot" },
  { id: "latest", label: "最新动态", href: "#latest" },
  { id: "columns", label: "追踪栏目", href: "#columns" },
  { id: "deep", label: "深度观察", href: "#deep" },
  { id: "spotlight", label: "焦点人物", href: "#spotlight" },
  { id: "faq", label: "常见问题", href: "#faq" },
];

export const categories = [
  { id: "zbfj", name: "主播近况", icon: "ri-user-heart-line", desc: "头部与腰部主播的开播、停播、换平台动作", count: 128 },
  { id: "drrc", name: "达人日常", icon: "ri-camera-lens-line", desc: "生活方式、才艺与知识类达人的内容日常", count: 96 },
  { id: "bgupdate", name: "博主更新", icon: "ri-article-line", desc: "图文与中长视频博主的更新节奏与内容转型", count: 154 },
  { id: "dv", name: "大V动向", icon: "ri-command-line", desc: "行业大V的言论、表态与账号变化观察", count: 63 },
  { id: "business", name: "商业动作", icon: "ri-store-line", desc: "签约、带货、自营与品牌合作一手动态", count: 87 },
  { id: "trend", name: "行业风向", icon: "ri-compass-3-line", desc: "平台政策、流量规则与内容趋势研判", count: 51 },
];

export const tickerItems = [
  "「晚晚梨」停播三月后回归，首场只聊天不带货",
  "「芋泥脑袋」回乡拍种田，两周涨粉破50万",
  "「表哥在广东」官宣退出美妆自营赛道",
  "平台严查搬家式搬运，原创奖励上调30%",
  "「阿彩的信箱」改名，疑似转播客赛道",
  "短剧达人批量转做直播切片，分成规则生变",
  "「鹿鹿大方」从时尚转型读书博主，评论两级",
];

export interface FeedItem {
  id: string;
  cat: string;
  title: string;
  summary: string;
  author: string;
  authorTag: string;
  timeLabel: string;
  views: string;
  likes: string;
  comments: string;
  image: string;
  isHot?: boolean;
  tag?: string;
}

export const feed: FeedItem[] = [
  {
    id: "f1",
    cat: "zbfj",
    title: "直播一姐「晚晚梨」停播三个月后悄悄回归，首场只聊天不带货",
    summary: "没有预告、没有冲榜，回归首场更像一场老友闲聊。她说自己需要找回“对着镜头说话”的欲望，带货反而想放一放。",
    author: "雷达观察组",
    authorTag: "主播近况",
    timeLabel: "12分钟前",
    views: "28.4万",
    likes: "1.2万",
    comments: "836",
    image: "https://readdy.ai/api/search-image?query=cozy%20warm%20live%20stream%20room%20of%20a%20female%20streamer%20with%20ring%20light%20and%20soft%20peach%20tones%2C%20editorial%20photography%2C%20natural%20window%20light%2C%20minimal%20decor%2C%20approachable%20atmosphere&width=900&height=600&seq=feed-01&orientation=landscape",
    isHot: true,
    tag: "热搜瓜",
  },
  {
    id: "f2",
    cat: "drrc",
    title: "生活区达人「芋泥脑袋」回老家种田，视频反而涨粉50万",
    summary: "在都市拍了三年精致早餐后，她选择回村陪爷爷奶奶种红薯。镜头里的泥土味，却成了粉丝眼里的新鲜感。",
    author: "雷达观察组",
    authorTag: "达人日常",
    timeLabel: "36分钟前",
    views: "52.1万",
    likes: "3.4万",
    comments: "2105",
    image: "https://readdy.ai/api/search-image?query=golden%20hour%20shot%20of%20a%20young%20woman%20in%20field%20holding%20sweet%20potatoes%2C%20warm%20rural%20sunset%20backdrop%2C%20documentary%20style%2C%20natural%20authentic%20candid%2C%20soft%20warm%20color%20grade&width=900&height=600&seq=feed-02&orientation=landscape",
    isHot: true,
    tag: "涨粉榜",
  },
  {
    id: "f3",
    cat: "business",
    title: "「豆豆严选」签约三名母婴达人，押注0-3岁场景化直播",
    summary: "把育儿场景拆成早教、辅食、睡眠三条线，配合线下探店，新一轮达人矩阵正式铺开。",
    author: "商业线报",
    authorTag: "商业动作",
    timeLabel: "1小时前",
    views: "9.6万",
    likes: "3200",
    comments: "418",
    image: "https://readdy.ai/api/search-image?query=clean%20bright%20baby%20products%20studio%20flatlay%20with%20soft%20toys%20and%20bottles%2C%20warm%20cream%20background%2C%20commercial%20product%20photography%2C%20gentle%20natural%20light&width=900&height=600&seq=feed-03&orientation=landscape",
  },
  {
    id: "f4",
    cat: "dv",
    title: "科技大V「键盘侠客」谈AI创作，被质疑“站着说话不腰疼”",
    summary: "他在长视频里呼吁同行拥抱AI工具，评论区却有创作者晒出“AI内容限流”截图，争议持续升温。",
    author: "风向观察",
    authorTag: "大V动向",
    timeLabel: "2小时前",
    views: "17.3万",
    likes: "5400",
    comments: "1982",
    image: "https://readdy.ai/api/search-image?query=modern%20minimal%20tech%20podcast%20studio%20with%20keyboard%20and%20monitor%20glow%2C%20warm%20accent%20lighting%2C%20editorial%20cinematic%2C%20focused%20workspace&width=900&height=600&seq=feed-04&orientation=landscape",
    tag: "热议",
  },
  {
    id: "f5",
    cat: "bgupdate",
    title: "时尚博主「鹿鹿大方」转型读书博主，评论区两级分化",
    summary: "从每日OOTD到一周一篇深度书评，更新频率降了一半，留下的粉丝却“含金量”更高了。",
    author: "雷达观察组",
    authorTag: "博主更新",
    timeLabel: "3小时前",
    views: "12.8万",
    likes: "4700",
    comments: "1302",
    image: "https://readdy.ai/api/search-image?query=stack%20of%20hardcover%20books%20on%20a%20warm%20wooden%20desk%20beside%20coffee%20and%20reading%20glasses%2C%20soft%20morning%20light%2C%20cozy%20editorial%20photography%2C%20warm%20neutral%20tones&width=900&height=600&seq=feed-05&orientation=landscape",
  },
  {
    id: "f6",
    cat: "zbfj",
    title: "电竞主播「电竞老K」换平台次日掉粉过万，官宣文案翻车",
    summary: "一条含糊的告别声明让老粉觉得“被背叛”，新平台的首播数据也未达预期，正在紧急补做粉丝沟通。",
    author: "雷达观察组",
    authorTag: "主播近况",
    timeLabel: "4小时前",
    views: "33.6万",
    likes: "9200",
    comments: "3560",
    image: "https://readdy.ai/api/search-image?query=moody%20gaming%20setup%20with%20rgb%20keyboard%20and%20dual%20monitors%20in%20warm%20amber%20light%2C%20esports%20ambience%2C%20editorial%20cinematic%2C%20dark%20accent&width=900&height=600&seq=feed-06&orientation=landscape",
    tag: "热议",
  },
  {
    id: "f7",
    cat: "bgupdate",
    title: "「山系青年老白」断更半年发长文复盘：焦虑是停更主因",
    summary: "他没有责怪流量，而是坦诚把“每期都要爆”的执念写成了六千字，反而收获一整屏的理解。",
    author: "雷达观察组",
    authorTag: "博主更新",
    timeLabel: "5小时前",
    views: "20.5万",
    likes: "1.8万",
    comments: "2740",
    image: "https://readdy.ai/api/search-image?query=male%20outdoor%20content%20creator%20backpacking%20through%20mountain%20trail%20at%20dusk%2C%20golden%20backlight%2C%20documentary%20outdoor%20editorial%2C%20warm%20film%20grain&width=900&height=600&seq=feed-07&orientation=landscape",
  },
  {
    id: "f8",
    cat: "drrc",
    title: "「深夜食堂阿佐」凌晨四点的菜市场vlog，治愈系播放破千万",
    summary: "没有美食教学，只有摊主们不打烊的深夜。这条视频被很多人当成“下饭白噪音”反复回看。",
    author: "雷达观察组",
    authorTag: "达人日常",
    timeLabel: "6小时前",
    views: "1012万",
    likes: "48万",
    comments: "9820",
    image: "https://readdy.ai/api/search-image?query=night%20wet%20market%20stalls%20with%20warm%20bulbs%20and%20fresh%20vegetables%2C%20steam%20rising%2C%20cinematic%20noir%20with%20warm%20highlights%2C%20documentary%20street%20photography&width=900&height=600&seq=feed-08&orientation=landscape",
    isHot: true,
    tag: "破圈",
  },
  {
    id: "f9",
    cat: "dv",
    title: "情感博主「阿彩的信箱」账号改名，疑似转型做播客",
    summary: "简介同步改为“声音专栏计划中”，几十万老粉正等着看她如何把树洞做成陪伴音频。",
    author: "风向观察",
    authorTag: "大V动向",
    timeLabel: "7小时前",
    views: "8.9万",
    likes: "3100",
    comments: "957",
    image: "https://readdy.ai/api/search-image?query=cozy%20podcast%20microphone%20on%20warm%20wooden%20desk%20with%20envelope%20and%20letters%2C%20soft%20amber%20lamp%20glow%2C%20warm%20editorial%20photography&width=900&height=600&seq=feed-09&orientation=landscape",
  },
  {
    id: "f10",
    cat: "business",
    title: "带货顶流「表哥在广东」退出美妆自营，转战食品严选",
    summary: "他在直播里算了一笔“售后账”，决定砍掉高退货的美妆自营，把精力放到复购更高的食品线。",
    author: "商业线报",
    authorTag: "商业动作",
    timeLabel: "9小时前",
    views: "41.7万",
    likes: "1.5万",
    comments: "2891",
    image: "https://readdy.ai/api/search-image?query=selection%20of%20asian%20snack%20food%20packaging%20and%20fresh%20ingredients%20on%20warm%20rustic%20wooden%20table%2C%20studio%20product%20photography%2C%20warm%20appetizing%20light&width=900&height=600&seq=feed-10&orientation=landscape",
    tag: "商业观察",
  },
  {
    id: "f11",
    cat: "trend",
    title: "平台严查“搬家式搬运”，原创达人流量奖励上调三成",
    summary: "这一次打击的不只是搬运，更指向“同质化换皮”。认真做原创的账号，有望吃到一轮红利。",
    author: "风向观察",
    authorTag: "行业风向",
    timeLabel: "11小时前",
    views: "14.2万",
    likes: "6300",
    comments: "1765",
    image: "https://readdy.ai/api/search-image?query=abstract%20data%20dashboard%20with%20upward%20growth%20chart%20and%20shield%20icon%20concept%2C%20warm%20amber%20and%20cream%20flat%20design%2C%20minimalist%20illustration%20style&width=900&height=600&seq=feed-11&orientation=landscape",
    tag: "政策",
  },
  {
    id: "f12",
    cat: "trend",
    title: "短剧达人批量转型直播切片，行业在等新的分成规则",
    summary: "当短剧投流成本一路走高，切片分发成了新出口。但版权归属与分成，仍是悬在头顶的问题。",
    author: "雷达观察组",
    authorTag: "行业风向",
    timeLabel: "13小时前",
    views: "11.3万",
    likes: "4100",
    comments: "1420",
    image: "https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20video%20editing%20timeline%20on%20desk%2C%20clapperboard%20and%20play%20button%20concept%2C%20warm%20desk%20lighting%2C%20editorial%20minimalist%20style&width=900&height=600&seq=feed-12&orientation=landscape",
  },
];

export interface RankItem {
  id: string;
  rank: number;
  title: string;
  tag: string;
  heat: string;
  delta: string;
  up?: boolean;
}

export const hotRank: RankItem[] = [
  { id: "r1", rank: 1, title: "「晚晚梨」停播三月后回归只聊天不带货", tag: "主播近况", heat: "98.6万", delta: "39%", up: true },
  { id: "r2", rank: 2, title: "「深夜食堂阿佐」凌晨菜市场视频破千万", tag: "破圈", heat: "92.1万", delta: "22%", up: true },
  { id: "r3", rank: 3, title: "「芋泥脑袋」回乡种田两周涨粉50万", tag: "涨粉榜", heat: "85.4万", delta: "45%", up: true },
  { id: "r4", rank: 4, title: "「电竞老K」换平台次日掉粉过万", tag: "热议", heat: "79.8万", delta: "12%", up: true },
  { id: "r5", rank: 5, title: "「表哥在广东」退出美妆自营转食品", tag: "商业观察", heat: "71.2万", delta: "8%", up: true },
  { id: "r6", rank: 6, title: "平台严查搬家式搬运，原创奖励上调", tag: "行业风向", heat: "63.7万", delta: "6%", up: false },
];

export interface DepthItem {
  id: string;
  index: string;
  title: string;
  excerpt: string;
  category: string;
  readTime: string;
  date: string;
  image: string;
}

export const depthPosts: DepthItem[] = [
  {
    id: "d1",
    index: "01",
    title: "谁在悄悄涨粉：2026上半年涨得最快的三类内容",
    excerpt: "我们把公开数据里的黑马账号摊开来看，发现涨粉的逻辑早已不是“拼勤奋”，而是回到了内容带来的真实情绪价值。",
    category: "行业研判",
    readTime: "12分钟",
    date: "09.06",
    image: "https://readdy.ai/api/search-image?query=rising%20chart%20with%20orange%20highlights%20and%20social%20media%20avatars%20floating%20above%2C%20warm%20cream%20background%2C%20minimalist%20editorial%203d%20illustration&width=1000&height=680&seq=depth-01&orientation=landscape",
  },
  {
    id: "d2",
    index: "02",
    title: "停更与转型：博主为何总在流量最高点按下暂停键",
    excerpt: "看似光鲜的数据背后，是被算法和期待绑住的手。我们和几位公开复盘过的创作者聊了聊“为什么想停下来”。",
    category: "创作者观察",
    readTime: "15分钟",
    date: "09.03",
    image: "https://readdy.ai/api/search-image?query=pause%20button%20icon%20on%20a%20blank%20warm%20page%20with%20coffee%20and%20open%20notebook%2C%20minimalist%20editorial%20illustration%2C%20soft%20natural%20light&width=1000&height=680&seq=depth-02&orientation=landscape",
  },
  {
    id: "d3",
    index: "03",
    title: "从“人设”到“真人”：粉丝开始为真实感买单",
    excerpt: "过度精致的包装越来越难留住人，愿意暴露一点笨拙与情绪的创作者，反而收获了更长情的陪伴。",
    category: "内容趋势",
    readTime: "9分钟",
    date: "08.29",
    image: "https://readdy.ai/api/search-image?query=two%20people%20having%20a%20warm%20genuine%20conversation%20over%20coffee%20in%20soft%20natural%20window%20light%2C%20candid%20documentary%20editorial%20photography%2C%20warm%20tones&width=1000&height=680&seq=depth-03&orientation=landscape",
  },
  {
    id: "d4",
    index: "04",
    title: "带货退潮之后，达人靠什么继续把生意做下去",
    excerpt: "当“全网最低价”失灵，我们梳理了几条被验证的路径：从卖货逻辑，转向真正经营人与信任的关系。",
    category: "商业拆解",
    readTime: "11分钟",
    date: "08.24",
    image: "https://readdy.ai/api/search-image?query=open%20retail%20storefront%20with%20warm%20lighting%20and%20shelves%2C%20trust%20and%20relationship%20commerce%20concept%2C%20editorial%20photography%2C%20cozy%20warm%20tones&width=1000&height=680&seq=depth-04&orientation=landscape",
  },
];

export interface Person {
  id: string;
  name: string;
  handle: string;
  category: string;
  change: string;
  changeType: "rise" | "stop" | "pivot";
  followers: string;
  blurb: string;
  avatar: string;
}

export const spotlights: Person[] = [
  {
    id: "p1",
    name: "晚晚梨",
    handle: "@wanwan_li",
    category: "主播 · 回归",
    change: "停播后回归，只聊天不带货",
    changeType: "stop",
    followers: "1880万",
    blurb: "停播三月后以聊天形式回归，直播间里不谈销量，只聊近况。",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20young%20chinese%20female%20streamer%20with%20soft%20smile%2C%20warm%20peach%20studio%20lighting%2C%20editorial%20headshot%2C%20clean%20cream%20background&width=400&height=400&seq=avatar-01&orientation=squarish",
  },
  {
    id: "p2",
    name: "芋泥脑袋",
    handle: "@yuni_naodai",
    category: "达人 · 涨粉",
    change: "回乡种田，两周涨粉50万",
    changeType: "rise",
    followers: "960万",
    blurb: "放弃都市精致早餐赛道，回到村里记录真实的田间生活。",
    avatar: "https://readdy.ai/api/search-image?query=warm%20portrait%20of%20a%20young%20chinese%20woman%20wearing%20straw%20hat%20in%20a%20field%2C%20golden%20sunlight%2C%20candid%20natural%20smile%2C%20editorial%20headshot%2C%20soft%20blur%20background&width=400&height=400&seq=avatar-02&orientation=squarish",
  },
  {
    id: "p3",
    name: "表哥在广东",
    handle: "@biaoge_gd",
    category: "带货 · 转型",
    change: "退出美妆自营，转战食品严选",
    changeType: "pivot",
    followers: "2340万",
    blurb: "把高退货的美妆自营砍掉，聚焦复购更高的食品自营线。",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20young%20chinese%20male%20seller%20in%20casual%20shirt%2C%20warm%20studio%20lighting%2C%20editorial%20headshot%2C%20clean%20background&width=400&height=400&seq=avatar-03&orientation=squarish",
  },
  {
    id: "p4",
    name: "鹿鹿大方",
    handle: "@lulu_dafang",
    category: "博主 · 转型",
    change: "时尚转读书，更新频率减半",
    changeType: "pivot",
    followers: "420万",
    blurb: "从每日穿搭更新转向每周深度书评，留下的粉丝黏性更高。",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20chinese%20female%20book%20blogger%20holding%20a%20hardcover%20book%2C%20warm%20library%20light%2C%20thoughtful%20expression%2C%20editorial%20headshot&width=400&height=400&seq=avatar-04&orientation=squarish",
  },
  {
    id: "p5",
    name: "山系青年老白",
    handle: "@laobai_outdoor",
    category: "博主 · 停更",
    change: "断更半年后发文复盘",
    changeType: "stop",
    followers: "315万",
    blurb: "坦诚写下六千字关于流量焦虑的复盘，收获评论区一整屏的理解。",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20chinese%20male%20outdoor%20creator%20in%20mountaineering%20jacket%20outdoors%2C%20golden%20hour%20light%2C%20rugged%20genuine%20smile%2C%20editorial%20headshot&width=400&height=400&seq=avatar-05&orientation=squarish",
  },
  {
    id: "p6",
    name: "阿彩的信箱",
    handle: "@acai_letters",
    category: "大V · 转型",
    change: "账号改名，疑似转做播客",
    changeType: "pivot",
    followers: "680万",
    blurb: "情感树洞博主把简介改成“声音专栏计划中”，正在铺一条陪伴音频线。",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20of%20a%20chinese%20female%20emotional%20columnist%20beside%20a%20retro%20microphone%2C%20warm%20amber%20lamp%20light%2C%20warm%20intimate%20mood%2C%20editorial%20headshot&width=400&height=400&seq=avatar-06&orientation=squarish",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "吃瓜雷达上的“瓜”是真的吗？信源可靠吗？",
    a: "我们坚持“有信源才吃瓜”的原则。每一条动态都会标注信息来源与公开可核验的线索（官方发文、直播切片、账号主页变更等），对无法确认的消息会明确标注为传闻待证，绝不以讹传讹。",
  },
  {
    q: "我关注的博主停更了，为什么还看不到原因？",
    a: "停更原因往往复杂且涉及个人隐私，很多博主并不会公开说明。我们会持续跟进账号是否恢复更新、主页简介是否变化等公开信号，一旦有明确线索会第一时间更新观察笔记。",
  },
  {
    q: "账号、商业或内容报道疑似失实，如何联系我们纠正？",
    a: "可在页面底部的投稿与纠错表单中提交链接与证据，我们核实后会第一时间更正或在原文标注补充说明，对确属失实的内容会做显著订正。",
  },
  {
    q: "关注谁、涨粉多少的数据从哪里来？",
    a: "粉丝、播放等数据均来自公开页面与公开数据口径，仅作为观察趋势的参考。不同平台统计方式不同，涨粉数据为相对变化趋势，不代表官方权威口径。",
  },
  {
    q: "我自己也是博主，能吃瓜雷达作为选题参考吗？",
    a: "可以。我们会拆解涨粉最快、转型成功的案例背后的内容方法与节奏，供想借鉴内容思路的创作者参考，帮助理解当下平台的流量偏好与用户口味。",
  },
];

export const countUpHighlights = [
  { label: "累计追踪动态", value: "12800+" },
  { label: "本周新增瓜点", value: "236" },
  { label: "覆盖创作者", value: "4600+" },
  { label: "深度观察专栏", value: "86" },
];